/**
 * Renders the header for a section of the Utah Code.
 * @param {string} chapterCode - The code for the chapter that the section belongs to.
 * @param {string} chapter - The name of the chapter that the section belongs to.
 * @param {string} effective - The effective date for the section.
 * @param {string} part - The name of the part that the section belongs to.
 * @param {string} partCode - The code for the part that the section belongs to.
 * @param {string} section - The name of the section.
 * @param {string} sectionCode - The code for the section.
 * @param {string} superseded - The superseded date for the section, if applicable.
 * @param {string} titleCode - The code for the title that the section belongs to.
 * @param {string} title - The name of the title that the section belongs to.
 * @returns {JSX.Element}
 */
export default function Header({
  chapterCode,
  chapter,
  effective,
  part,
  partCode,
  section,
  sectionCode,
  superseded,
  titleCode,
  title,
}) {
  return (
    <header className="font-bold">
      <div className="pl-10">
        <div>Index Utah Code</div>
        <div>
          Title {titleCode} {title}
        </div>
        <div>
          Chapter {chapterCode} {chapter}
        </div>
        <div>
          Part {partCode} {part}
        </div>
        <div>
          Section {sectionCode} {section}{' '}
          <span className="font-normal italic">
            (Effective {effective}) (Superseded {superseded})
          </span>
        </div>
      </div>
      <div className="pl-6 pr-4 pt-8">
        <div className="italic">Effective {effective}</div>
        <div className="italic">Superseded {superseded}</div>
        <div>
          {titleCode}-{chapterCode}-{sectionCode}. {section}
        </div>
      </div>
    </header>
  );
}
